import { FOSTER_SPONSOR, PLATINUM_FOSTER_SPONSOR } from "../../../../../common/constants/sponsor-constants";
import { BasicSponsor } from "../../Sponsorship/Sponsorship";
import SponsorDetail from "../SponsorDetail";

type Sponsor = { isPlatinum: boolean } & BasicSponsor;

type Props = {
  fosterSponsor: Sponsor;
};

const LeafFosterOrFosterAndPlatinumSponsor = (props: Props) => {
  const { fosterSponsor } = props;
  const { isValid } = fosterSponsor;
  const sponsorType = fosterSponsor.isPlatinum === true ? PLATINUM_FOSTER_SPONSOR : FOSTER_SPONSOR;

  return <SponsorDetail sponsor={fosterSponsor} show={isValid} sponsorType={sponsorType} />;
};

export default LeafFosterOrFosterAndPlatinumSponsor;
